import Avatar from "@mui/material/Avatar";
import useAuth from "src/hooks/useAuth";

// import { AAvatar } from "./@material-extend";
// import createAvatar from "src/utils/createAvatar";

export default function MyAvatar({ ...other }) {
  const {
    // profiles,
    profileId,
  } = useAuth();

  return (
    // <AAvatar
    //   src={user.avatar}
    //   alt={user.firstname}
    //   color={user.avatar ? "default" : createAvatar(user.firstname).color}
    //   {...other}
    // >
    //   {createAvatar(user.firstname).name}
    // </AAvatar>
    // <Avatar src={profiles.find(profile => profile.id === parseInt(profileId))} />
    <Avatar src={`/static/images/account/${profileId}.jpg`} />
  );
}
